//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import SelectAssetInfoModal from "../../../assets/SelectAssetInfoModal";
import { queryUserTreeList } from '@/api/api';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'ScrapModal',
  components: {
    SelectAssetInfoModal: SelectAssetInfoModal,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      userTree: [],
      //人员信息
      selectedProduct: [],
      productIds: [],
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        stime: {
          rules: [{
            required: true,
            message: '请输入报废时间!'
          }]
        },
        remark: {
          rules: [{
            required: true,
            message: '请输入报废原因!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入报废人!'
          }]
        }
      },
      url: '/om/asset/scrap' // url: {
      //   add: '/om/asset/scrap/add',
      //   edit: '/om/asset/scrap/edit',
      // },

    };
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadTreeList();
      this.selectedProduct = [];
      this.productIds = [];

      if (!this.model.id) {
        this.model.stime = new Date().toLocaleDateString();
        this.model.userId = this.loginUser;
      }

      if (this.model.assetId) {
        this.productIds = this.model.assetId;
        this.selectedProduct.push(this.model.productName);
      }

      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'assetId', 'stime', 'remark', 'userId')); //时间格式化


        _this.form.setFieldsValue({
          stime: _this.model.stime ? moment(_this.model.stime) : null
        });

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    selectProducts: function selectProducts() {
      this.$refs.ProductListModal.category = this.category;
      this.$refs.ProductListModal.disableSubmit = true;
      this.$refs.ProductListModal.add(this.selectedProduct, this.productIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedProduct = [];
      this.productIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedProduct.push(productList[i].productName);
        this.productIds = productList[i].id;
      }
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url;
            method = 'post';
          } else {
            httpurl = _this2.url;
            method = 'put';
          }

          var formData = Object.assign(_this2.model, values); //时间格式化

          formData.stime = formData.stime ? formData.stime.format('YYYY-MM-DD') : null;
          formData.assetId = that.productIds && (that.productIds == [] || that.productIds.length == 0) ? '' : that.productIds;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
              that.close();
            } else {
              that.$message.warning(res.message);
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};